module.exports = __webpack_public_path__ + "img/server_1.db4902ab.jpg";